// extracted by css-extract-rspack-plugin
module.exports =  {"postcode":"PostcodeInput__postcode--cW34h","firstCode":"PostcodeInput__firstCode--jlvpu","lastCode":"PostcodeInput__lastCode--LAfgc"};